<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="vx-row md:w-1/2 pl-4">
        <div class="w-full md:w-1/2 pr-4">
          <label for="">{{$t('realtimeChart.boxTime')}}</label>
          <v-select
            v-model="timeLineSelected"
            :options="optionalTimeline"
            :placeholder="$t('realtimeChart.placeTime')"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <div class="w-full md:w-1/2">
          <label for="">{{$t('realtimeChart.boxData')}}</label>
          <v-select
            v-model="refreshDataSelected"
            :options="optionalRefreshData"
            :placeholder="$t('realtimeChart.placeTimeData')"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="data-log">
          <span>{{$t('realtimeChart.titleData')}} {{ viewData }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <div class="app">
            <div id="chart">
              <vue-apex-charts
                height="700"
                type="line"
                ref="chart"
                :options="chartOptions"
                :series="series"
              ></vue-apex-charts>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="vx-row mt-8">
        <div class="vx-col mt-2 w-full">
          <div class="app">
            <div id="chart">
              <vue-apex-charts
                height="500"
                type="bar"
                :options="chartOptionsBar"
                :series="series"
              ></vue-apex-charts>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
export default {
  components: {
    VueApexCharts,
    vSelect
  },
  data: function() {
    return {
      viewData: null,
      setResetData: null,
      timeLine: 5000,
      refreshData: 30000,
      dataRow: [],
      optionalTimeline: [
        { label: "5s", value: 5000 },
        { label: "10s", value: 10000 },
        { label: "1 phút trước", value: 60000 },
        { label: "5 phút", value: 300000 },
        { label: "30 phút", value: 1800000 },
        { label: "1 tiếng", value: 6000000 },
        { label: "4 tiếng", value: 24000000 },
        { label: "12 tiếng", value: 12000000 },
        { label: "1 ngày", value: 24000000 }
      ],
      optionalRefreshData: [
        { label: "5 phút", value: 30000 },
        { label: "10 phút", value: 60000 },
        { label: "30 phút", value: 180000 },
        { label: "1 tiếng", value: 360000 }
      ],
      chartOptions: {
        chart: {
          id: "vuechart-example",
          type: "line",
          animations: {
            enabled: true,
            easing: "linear",
            dynamicAnimation: {
              speed: 1000
            }
          },
          toolbar: {
            show: false
          }
        },
        zoom: {
          enabled: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        markers: {
          size: 0
        },
        xaxis: {
          range: 10,
          categories: [moment(new Date()).format("HH:mm:ss")]
        },
        yaxis: {
          // categories: [0,500,1000,2000,4000,6000,8000,10000,15000,20000],
          style: {
            cssClass: "text-grey fill-current"
          },
          tickAmount: 5,
          labels: {
            show: true,
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        },
        title: {
          text: "Dynamic Updating Chart",
          align: "left"
        }
      },
      series: [
        {
          name : this.$t('realtimeChart.data'),
          data: []
        }
      ],
      legend: {
        show: false
      }

      // chartOptionsBar: {
      //   chart: {
      //     height: 350,
      //     type: "bar",
      //     animations: {
      //       enabled: true,
      //       dynamicAnimation: {
      //         speed: 5000
      //       }
      //     }
      //   },
      //   // plotOptions: {
      //   //   bar: {
      //   //     dataLabels: {
      //   //       position: "bottom"
      //   //     }
      //   //   }
      //   // },
      //   dataLabels: {
      //     enabled: false,
      //     formatter: function(val) {
      //       return val + "%";
      //     },
      //     offsetY: -20,
      //     style: {
      //       fontSize: "12px",
      //       colors: ["#304758"]
      //     }
      //   },
      //   xaxis: {
      //     categories: [],
      //     range: 5,
      //     position: "bottom",
      //     axisBorder: {
      //       show: false
      //     },
      //     axisTicks: {
      //       show: false
      //     },
      //     crosshairs: {
      //       fill: {
      //         type: "gradient",
      //         gradient: {
      //           colorFrom: "#D8E3F0",
      //           colorTo: "#BED1E6",
      //           stops: [0, 100],
      //           opacityFrom: 0.4,
      //           opacityTo: 0.5
      //         }
      //       }
      //     },
      //     tooltip: {
      //       enabled: false
      //     }
      //   },
      //   yaxis: {
      //     axisBorder: {
      //       show: false
      //     },
      //     axisTicks: {
      //       show: false
      //     },
      //     labels: {
      //       show: true,
      //       formatter: function(val) {
      //         return val.toFixed(0);
      //       }
      //     },
      //     tickAmount: 5,
      //     categories: []
      //   }
      //   // title: {
      //   //   text: "CharBar",
      //   //   floating: true,
      //   //   offsetY: 330,
      //   //   align: "center",
      //   //   style: {
      //   //     color: "#444"
      //   //   }
      //   // }
      // }
    };
  },
  computed: {
    timeLineSelected: {
      get() {
        let label = null;
        let object = this.optionalTimeline.find(
          el => el.value === this.timeLine
        );
        if (!object) {
          return null;
        }

        if (object && object.label.length > 20) {
          label = object.label.slice(0, 20) + "...";
        } else {
          label = object.label;
        }

        return {
          label: label,
          value: this.timeLine
        };
      },
      set(object) {
        this.timeLine = object.value;
        clearInterval(this.setResetData);
        this.setResetData = null;
        this.initScreen();
      }
    },
    refreshDataSelected: {
      get() {
        let label = null;
        let object = this.optionalRefreshData.find(
          el => el.value === this.refreshData
        );
        if (!object) {
          return null;
        }

        if (object && object.label.length > 20) {
          label = object.label.slice(0, 20) + "...";
        } else {
          label = object.label;
        }

        return {
          label: label,
          value: this.refreshData
        };
      },
      set(object) {
        this.refreshData = object.value;
        clearInterval(this.setResetData);
        this.setResetData = null;
        this.initScreen();
      }
    }
  },
  methods: {
    countData: function() {
      const payload = {};
      this.$processor.post("/user-data/count-data", payload).then(res => {
        this.viewData = res.data.countData;
        let data = this.series[0].data;
        data.push(res.data.countData);
        this.dataRow = data;
        this.series = [
          {
            data: this.dataRow
          }
        ];

        // const categoriesChartBar = this.chartOptionsBar.xaxis.categories;
        // categoriesChartBar.push(timeLine);
      });
    },
    initScreen: function() {
      this.setResetData = window.setInterval(() => {
        let timeLine = moment(new Date()).format("HH:mm:ss");
        const categories = this.chartOptions.xaxis.categories;
        categories.push(timeLine);
        this.countData();
        if (this.$refs.chart && this.$refs.chart.updateSeries) {
          this.$refs.chart.updateSeries([
            {
              data: this.dataRow
            }
          ]);
        }
      }, this.timeLine);
      window.setInterval(() => {
        this.dataRow = [];
        this.$refs.chart.updateSeries(
          [
            {
              data: this.dataRow
            }
          ],
          false,
          true
        );
      }, 1200000);
    },
    checkOptionalTimeline : function () {
      this.optionalTimeline[2].label = this.$t('realtimeChart.text1p')
      this.optionalTimeline[3].label = this.$t('realtimeChart.text5p')
      this.optionalTimeline[4].label = this.$t('realtimeChart.text30p')
      this.optionalTimeline[5].label = this.$t('realtimeChart.text1t')
      this.optionalTimeline[6].label = this.$t('realtimeChart.text4t')
      this.optionalTimeline[7].label = this.$t('realtimeChart.text12t')
      this.optionalTimeline[8].label = this.$t('realtimeChart.text1day')
    },
    checkOptionalRefreshData : function () {
      this.optionalRefreshData[0].label = this.$t('realtimeChart.text5p')
      this.optionalRefreshData[1].label = this.$t('realtimeChart.text10p')
      this.optionalRefreshData[2].label = this.$t('realtimeChart.text30p')
      this.optionalRefreshData[3].label = this.$t('realtimeChart.text1t')
    },
  },

  mounted() {},
  async created() {
    this.initScreen();
    this.$eventBus.$on('i18n' , () => {
      this.checkOptionalTimeline();
      this.checkOptionalRefreshData()
    })
    this.checkOptionalTimeline();
    this.checkOptionalRefreshData()

  }
};
</script>
<style scoped>
.data-log {
  position: absolute;
  right: 10rem;
  top: 3rem;
  font-size: 1.5rem;
  font-weight: bold;
}
</style>
